import React from 'react';

import { Container, LineArea, Points, Point, Line, Text } from './styles';

interface Props {
  topText?: string;
  bottomText?: string;
  points?: number;
  className?: string;
}

const Flightline = ({ topText, bottomText, points = 0, className }: Props) => (
  <Container className={className || ''}>
    {topText && <Text>{topText}</Text>}
    <LineArea>
      <Line />
      {points > 0 && (
        <Points>
          {points.toArray().map((point) => (
            <Point key={point} />
          ))}
        </Points>
      )}
    </LineArea>
    <Text>{bottomText}</Text>
  </Container>
);

export default Flightline;
